<template>
  <div class="schedule">
    <div class="container">
      <ShadowTitle :title="`Расписание мероприятия`"
                   title-shadow="EVENT"
      />
      <div class="swiper-container swiper-schedule">
        <div :class="windowSize <= 768 ? 'swiper-wrapper' : 'row g-5'">
          <div :class="windowSize <= 768 ? 'swiper-slide' : 'col-12 col-md-6'">
            <div class="schedule-item">
              <div class="schedule-item_head">
                <div class="schedule-item_title">
                  <div class="date">
                    9 марта
                  </div>
                  <div class="count">
                    Первый <br>день
                  </div>
                </div>
                <div class="schedule-item_subtitle">
                  Пространство событий «Матрешка» <br>Инновационного центра Сколково
                </div>
              </div>
              <div class="schedule-item_body">
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    09:30 - 11:00
                  </div>
                  <div class="schedule-item_event">
                    welcome-<br class="d-md-none d-lg-block d-xl-none">регистрация
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    11:00
                  </div>
                  <div class="schedule-item_event">
                    начало мероприятия
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    11:00 - 13:00
                  </div>
                  <div class="schedule-item_event">
                    презентация пространства SPACE
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    13:00 - 14:30
                  </div>
                  <div class="schedule-item_event">
                    обед
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    14:30 - 17:30
                  </div>
                  <div class="schedule-item_event">
                    человек 10.0 <br>кто он?
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    17:30 - 18:00
                  </div>
                  <div class="schedule-item_event">
                    фуршет-нетворкинг
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    18:00 - 20:30
                  </div>
                  <div class="schedule-item_event">
                    anti-conference формат. Активности в тематических зонах
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    20:30 - 21:00
                  </div>
                  <div class="schedule-item_event">
                    технический перерыв
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    21:00 - 22:30
                  </div>
                  <div class="schedule-item_event">
                    музыкально-поэтический концерт Ивана Кокорина «Поэзия и время»
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="windowSize <= 768 ? 'swiper-slide' : 'col-12 col-md-6'">
            <div class="schedule-item">
              <div class="schedule-item_head">
                <div class="schedule-item_title">
                  <div class="date">
                    10 марта
                  </div>
                  <div class="count">
                    Второй <br>день
                  </div>
                </div>
                <div class="schedule-item_subtitle">
                  Отель «Альянс Бородино».<br>В стиле TEDx о ELS SPACE: <br>как зарабатывать со SPACE BUSINESS
                </div>
              </div>
              <div class="schedule-item_body">
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    10:00 - 11:00
                  </div>
                  <div class="schedule-item_event">
                    сбор <br class="d-md-none d-lg-block d-xl-none">гостей
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    11:00
                  </div>
                  <div class="schedule-item_event">
                    начало мероприятия
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    11:00 - 13:30
                  </div>
                  <div class="schedule-item_event">
                    о пространстве нового<br> типа — SPACE
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    13:30 - 14:30
                  </div>
                  <div class="schedule-item_event">
                    обед
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    14:30 - 18:00
                  </div>
                  <div class="schedule-item_event">
                    безграничные<br> возможности SPACE
                  </div>
                </div>
                <div class="schedule-item_row">
                  <div class="schedule-item_time">
                    18:00 - 19:00
                  </div>
                  <div class="schedule-item_event">
                    кофе-брейк
                  </div>
                </div>
                <div class="schedule-item_row border-mob">
                  <div class="schedule-item_time">
                    19:00 - 22:00
                  </div>
                  <div class="schedule-item_event">
                    церемония награждения
                  </div>
                </div>
                <div class="schedule-item_row row-full-mob d-md-none"/>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination swiper-schedule-pagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {nextTick, onMounted, onUnmounted, ref, watch} from "vue";
import Swiper from "swiper";
import {Pagination} from 'swiper/modules';
import 'swiper/swiper.css';

import ShadowTitle from "@/components/ShadowTitle";

export default {
  name: "Schedule",
  components: {ShadowTitle},
  setup() {
    const swiperInstance = ref(null);
    const windowSize = ref(window.innerWidth);

    const initializeSwiper = () => {
      nextTick(() => {
        if (windowSize.value <= 768) {
          if (!swiperInstance.value) {
            swiperInstance.value = new Swiper('.swiper-schedule', {
              modules: [Pagination],
              pagination: {
                el: '.swiper-schedule-pagination',
                clickable: true,
              },
              breakpoints: {
                0: {
                  slidesPerView: 1.1,
                  spaceBetween: 16
                },
                400: {
                  slidesPerView: 1.5,
                  spaceBetween: 16
                },
              }
            });
          }
        } else if (swiperInstance.value) {
          swiperInstance.value.destroy();
          swiperInstance.value = null;
        }
      });
    }
    const handleResize = () => {
      windowSize.value = window.innerWidth;
    };

    watch(windowSize, initializeSwiper);

    onMounted(() => {
      initializeSwiper();
      window.addEventListener('resize', handleResize);
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    return {
      windowSize,
    }
  },
}
</script>
<style lang="scss" scoped>
.schedule-item {
  border-radius: 16px;
  border: 1px solid #37373C;
  display: flex;
  flex-direction: column;
}

.schedule-item_row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 12px;

  &.border-mob {
    border-bottom: inherit;
    @include _768 {
      border-bottom: none !important;
    }
  }

  &:nth-child(3) {
    flex-basis: 134px;
  }

  &:nth-child(5) {
    flex-basis: 94px;
  }

  &:nth-child(6) {
    flex-basis: 74px;
  }

  &:nth-child(7) {
    flex-basis: 174px;
  }
  &:nth-child(8) {
    flex-basis: 100px;
  }

  &:nth-child(9) {
    flex-basis: 174px;
  }

  &.row-full-mob {
    flex-basis: 274px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #37373C;
  }

  @include _768 {
    flex-basis: auto !important;
  }

  @include _992 {
    padding: 24px;
  }
}

.schedule-item_head {
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  @include _992 {
    padding: 20px 40px;
  }

  .schedule-item_subtitle {
    color: var(--gray, #C7C7D1);
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 136%; /* 24.48px */
    margin-bottom: 20px;
    flex-basis: 122px;

    br {
      display: none;
    }

    @include _576 {
      flex-basis: 72px;
    }

    @include _992 {
      br {
        display: block;
      }
    }
  }

  .schedule-item_title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 20px;

    .date {
      font-family: Play, serif;
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 128%; /* 35.84px */
      @include _992 {
        font-size: 38px;
      }
    }

    .count {
      color: var(--gray, #C7C7D1);
      text-align: right;
      font-family: Play, serif;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 112%; /* 20.16px */
      @include _992 {
        br {
          display: none;
        }
      }
    }
  }
}

.schedule-item_body {
  display: flex;
  flex-direction: column;

  .schedule-item_time {
    width: 48%;
    color: var(--gray, #C7C7D1);
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 136%; /* 24.48px */
    @include _992 {
      width: 30%;
    }
  }

  .schedule-item_event {
    width: 52%;
    color: var(--white, #FFF);
    font-family: Play, serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 112%; /* 20.16px */
    @include _992 {
      font-size: 26px;
      width: 70%;
    }
  }
}
</style>